import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const GroupGeneticAlgo = ({group}) => { 
    const [generation, setGeneration] = useState(group.generation);
    const [selected, setSelected] = useState(group.selectedVariation);

    const onBreed = useCallback(() => {
        group.reproduce();
        setGeneration(group.generation);
    }, [setGeneration, group]);

    useEffect(() => {
        setSelected(undefined);
    }, [generation, setSelected]);

    useEffect(() => {
        if (selected !== undefined) {
            group.selectVariation(selected);
        }
    }, [selected]);
    
    const onClickVariation = useCallback((num) => {
        group.selectBest(num);
        if (selected === num) {
            setSelected(undefined);
        } else {
            setSelected(num);
        }
    }, [setSelected, selected]);

    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [group, setSelected, selected]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            if (selected !== undefined) {
                if (selected === 0) {
                    setSelected(15);
                } else {
                    setSelected((selected - 1));
                }
            } else {
                setSelected(0);
            }
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            if (selected !== undefined) {
                setSelected((selected + 1)%16);
            }  else {
                setSelected(0);
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (e.ctrlKey) {
                onBreed();
            } else {
                chooseBest();
            }
        }
    }, [group, setSelected, selected]);

    const chooseBest = useCallback(() => {
        if (selected === undefined) {
            return;
        }
        group.selectBest(selected);
        setSelected(undefined);
        setSelected(selected);
    }, [selected, setSelected]);

    if (generation === 0) {
        return (
            <div
              onClick={onBreed}
              className="genetic-btn">
              Create Variations
            </div>
        );
    }

    const getVariations = (variations) => {
        return variations.map(
            (variation, i) =>
                <Variation
                  onClick={() => onClickVariation(group.variations.indexOf(variation))}
                  isSelected={selected === group.variations.indexOf(variation)}
                  isBest={group._bestSolutions.includes(group.variations.indexOf(variation))}
                  key={i}
                  variation={variation}
                  i={group.variations.indexOf(variation)}
                  group={group}/>);
    };

    let variations = group.variations;
    return (
        <div className="genetic-algo">
          <div className="generation">
            <div className="generation-label">
              Generation: {generation}
            </div>
            <div onClick={onBreed} className="breed-button">
              Breed Variations
            </div>
          </div>
          {group.categories ?
           <div className="variations">
             <div className="elite">
               <div className="label">Elite</div>
               {getVariations(group.categories.elite)}
             </div>
             <div className="children">
               <div className="label">Children</div>
               {getVariations(group.categories.children)}
             </div>
             <div className="mutations">
               <div className="label">Mutations</div>
               {getVariations(group.categories.mutations)}
             </div>
           </div> : 
           <div className="variations">
             {variations.map(
                 (variation, i) =>
                     <Variation
                       onClick={() => onClickVariation(i)}
                       isSelected={selected === i}
                       isBest={group._bestSolutions.includes(i)}
                       key={i}
                       variation={variation}
                       i={i}
                       group={group}/>)}
           </div>}
        </div>
    );
};

const Variation = ({isBest, isSelected, group, variation, i, onClick}) => {
    let className = "variation";
    if (isBest) {
        className += " best";
    }
    if (isSelected) {
        className += " selected";
    }
    return (
        <div onClick={onClick} className={className}>
          {i + 1}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupGeneticAlgo);
